import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import _map from 'lodash/map';
import _values from 'lodash/values';
import AuthorizedRoute from 'commons-ui/src/permission/AuthorizedRoute';

import { URL as DASHBOARD_URL } from 'pages/dashboard/helper';
import { DASHBOARD_RESOURCES } from 'constant';
import { URL as FINANCE_URL, FINANCE_RESOURCES } from '../helper';
import DynamicSwitcherHome from './DynamicSwitcherHome';
import { URL, COMPONENT, DYNAMIC_SWITCHER_RESOURCES, GET_ACTION } from './dynamicSwitcherHelper';

const DynamicSwitcherDashboardHome: React.FC = () => {
	return (
		<>
			<Switch>
				<AuthorizedRoute
					exact
					configPageName={DASHBOARD_RESOURCES.finance}
					configResourceName={FINANCE_RESOURCES.dynamicSwitcher}
					configActionName='GetAllDynamicSwitcherCards'
					path={FINANCE_URL[FINANCE_RESOURCES.dynamicSwitcher]}
					component={DynamicSwitcherHome}
				/>
				{_map(_values(DYNAMIC_SWITCHER_RESOURCES), (subEntity) => (
					<AuthorizedRoute
						key={subEntity}
						configPageName={FINANCE_RESOURCES.dynamicSwitcher}
						configResourceName={subEntity}
						configActionName={GET_ACTION[subEntity]}
						path={URL[subEntity]}
						component={COMPONENT[subEntity]}
					/>
				))}
				<Redirect to={DASHBOARD_URL[DASHBOARD_RESOURCES.finance]} />
			</Switch>
		</>
	);
};

export default DynamicSwitcherDashboardHome;
